import moment from "moment";
import api from "../../services/apiEndpoints";

export const calendarViewMixin = {
    methods: {
        populateCurrentViewAndDate() {
            let currentDate = moment().format("YYYY-MM-DD");

            this.newCurrentDate = currentDate;
            this.bookData.date = moment(currentDate).toDate();
            this.secondaryDatepickerDate = this.addTimeToDate(this.bookData.date, 1, "M");

            let currentView = localStorage.getItem("calendarView");
            if (typeof currentView !== "undefined" && currentView !== null) {
                if (currentView === "resourceTimeGridDay" && (this.newIsGroup || this.groupMemberDisplayAll)) {
                    currentView = "resourceTimeGridDay";
                }
            } else {
                if (this.user.role === "client") {
                    currentView = "dayGridMonth";
                } else {
                    if (this.user.details.group_owner && this.user.details.group_active) {
                        currentView = "resourceTimeGridDay";
                    } else {
                        currentView = "timeGridWeek";
                    }
                }
            }

            this.newCurrentView = currentView;
        },
        changeCurrentView(view) {
            //change the view based upon the local storage setting
            localStorage.setItem("calendarView", view);
            this.newCurrentView = view;
            if (this.user.role === "stylist") {
                this.getFullCalendarApi().changeView(view, this.newCurrentDate);
            }
        },
        saveCalendarView(view) {
            let allowed_views = [1, 3, 7, 30];

            if (allowed_views.indexOf(view) == -1) {
                return;
            }

            let data = {
                calendar_view: view,
            };

            this.$http.post(api.actions.save_calendar_view, data);
        },
        getCalendarView() {
            this.$http.get(api.actions.get_calendar_view).then((res) => {
                let allowed_views = {
                    1: "resourceTimeGridDay",
                    3: "timeGridThreeDays",
                    7: "timeGridWeek",
                    30: "dayGridMonth",
                };

                if (!allowed_views[res.data.calendar_view]) {
                    return;
                }

                this.changeCurrentView(allowed_views[res.data.calendar_view]);
            });
        },

        newSetCurrentViewAndDate() {
            let view = localStorage.getItem("calendarView");

            if (!view) {
                view =
                    this.user.role === "client"
                        ? "dayGridMonth"
                        : this.user.details.group_owner && this.user.details.group_active
                          ? "resourceTimeGridDay"
                          : "timeGridWeek";
            }

            this.newCurrentView = view;
            this.newCurrentDate = moment().format("YYYY-MM-DD");

            const api = this.getFullCalendarApi();
            if (!api) return;
            api.changeView(view);
            api.gotoDate(this.newCurrentDate);
        },
        
        handleNextCalendarView() {
            if (!this.showStylistSpecificAppointments) {
                return;
            }

            if (this.newCurrentView === "dayGridMonth") {
                this.handleWeekButtonClick();
            }

            if (this.newCurrentView === "timeGridWeek") {
                this.handleThreeDaysButtonClick();
            }

            if (this.newCurrentView === "timeGridThreeDays") {
                this.handleDayButtonClick();
            }

            if (this.newCurrentView === "resourceTimeGridDay") {
                this.handleMonthButtonClick();
            }
        },
    },
};
